import React, {useState} from 'react';
import {connect} from 'react-redux';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    Nav,
    Dropdown,
    Modal,
    ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import {faAngleDown,} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Trans, useTranslation} from "react-i18next";

import {shopsRequestStart, shopsSelectShop} from "../../../actions/Shops";
import {setEnableMobileMenuSmall} from '../../../actions/ThemeOptions'
import bg3 from '../../../assets/utils/images/dropdown-header/abstract3.jpg';
import get from "lodash/get";
import cx from "classnames";


const MegaMenu = (
    {
        shops,
        activeShop,
        shopsSelectShop,
        isSendingRequest,
        shopsRequestStart,
        setEnableMobileMenuSmall,
    }
) => {
    const {t, i18n} = useTranslation();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState();

    const toggle = () => {
        if (isSendingRequest) {
            return
        }

        if (dropdownOpen === false) {
            shopsRequestStart('');
        }
        setDropdownOpen(!dropdownOpen);
    };

    const selectShop = (shop) => {
        if (activeShop.id !== shop.id) {
            shopsSelectShop(shop);
            shopsRequestStart('');
            setEnableMobileMenuSmall(false);
        }
    };


    let dropdownShopItems = shops.map((shop) => {
        return <div
            key={shop.id}
            className={cx({"active": (shop.id === activeShop.id), "hover-pointer rounded dropdown-item": true})}
            onClick={() => selectShop(shop)}
        >
            {shop.trade_name}
        </div>
    });

    return <>
        {shops.length > 1 &&
            <div className="metismenu vertical-nav-menu   mt-4 ">
                <ul className="metismenu-container" onClick={() => {
                    toggle(true)
                }}>
                    <li className="metismenu-item">
                        <a className="metismenu-link hover-pointer">
                            <i className="metismenu-icon  pe-7s-way"> </i>
                            {t('layout.vertical_nav.menu.settings.change_instance', 'Switch instance')}
                        </a>
                    </li>

                    <Modal isOpen={dropdownOpen}
                           toggle={() => setDropdownOpen(false)}
                           size='lg'
                        // centered={true}
                    >
                        <ModalHeader toggle={() => setDropdownOpen(false)}
                                     cssModule={{'modal-title': 'w-100 text-center mb-0'}}>
                            {t('layout.vertical_nav.menu.settings.change_instance', 'Switch instance')}
                        </ModalHeader>
                        <ModalBody>


                            {dropdownShopItems}


                        </ModalBody>
                    </Modal>


                </ul>
            </div>
        }
    </>;
};

const mapStateToProps = state => ({
    shops: state.Shops.shops,
    activeShop: state.Shops.activeShop,
    isSendingRequest: state.Shops.isSendingRequest,
});

const mapDispatchToProps = dispatch => ({
    shopsRequestStart: (search, setIsSendingRequest) => dispatch(shopsRequestStart(search, setIsSendingRequest)),
    shopsSelectShop: shop => dispatch(shopsSelectShop(shop)),
    setEnableMobileMenuSmall: enabled => dispatch(setEnableMobileMenuSmall(enabled)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MegaMenu);
